export const addressEntries = [
  {
    id: "main-1",
    name: "主线路一",
    url: "97v-main.net",
    line: "main",
    status: "online",
    speed: "极快",
    note: "日常首选线路，更新最及时。建议先收藏并设为浏览器主页，作为第一顺位入口。",
    tags: ["推荐", "更新及时"],
    updatedAt: "2026-10-10",
  },
  {
    id: "main-2",
    name: "主线路二",
    url: "97v-main2.net",
    line: "main",
    status: "online",
    speed: "快",
    note: "与主线路一同步更新，两条主线路可互为备份，一条拥堵时切换另一条即可。",
    tags: ["同步更新", "互为备份"],
    updatedAt: "2026-10-10",
  },
  {
    id: "backup-1",
    name: "备用线路一",
    url: "97v-backup.net",
    line: "backup",
    status: "backup",
    speed: "稳定",
    note: "仅在主线路无法访问时启用，稳定性较好，适合作为第二顺位备用入口长期收藏。",
    tags: ["备用", "稳定"],
    updatedAt: "2026-10-09",
  },
  {
    id: "backup-2",
    name: "备用线路二",
    url: "97v-fallback.net",
    line: "backup",
    status: "backup",
    speed: "稳定",
    note: "另一条长期维护的备用通道，与备用线路一分布在不同的服务节点上，互不影响。",
    tags: ["备用", "独立节点"],
    updatedAt: "2026-10-08",
  },
  {
    id: "mobile-1",
    name: "移动优化线路",
    url: "m.97v-mobile.net",
    line: "mobile",
    status: "online",
    speed: "快",
    note: "针对蜂窝网络做过加载优化，在移动数据或弱网环境下打开更顺畅，适合手机用户。",
    tags: ["移动端", "弱网优化"],
    updatedAt: "2026-10-10",
  },
  {
    id: "mirror-1",
    name: "镜像入口",
    url: "97v-mirror.net",
    line: "mirror",
    status: "backup",
    speed: "一般",
    note: "内容与主站保持一致，更新频率略低，作为前几项都无法访问时的最后备选方案。",
    tags: ["镜像", "最后备选"],
    updatedAt: "2026-10-06",
  },
];

export const addressLineTabs = [
  { id: "all", label: "全部入口" },
  { id: "main", label: "主线路" },
  { id: "backup", label: "备用线路" },
  { id: "mobile", label: "移动优化" },
  { id: "mirror", label: "镜像入口" },
];